import { Typography } from '@/components/ui/typography';

import { DetailField } from './DetailField';
import {
  radioOption,
  isActiveRadioOption,
  rentReadySelection,
  isListedSelection,
  isActiveSelection,
} from '../../add-property/hooks/propertyFormUtils';
import { leaseStatusOptions } from '../../../../config/options.config';

import type { PropertyEntity } from '../../../../types/property.types';

interface Props {
  property: PropertyEntity;
}

export function LeasingDetailsTab({ property }: Props) {
  return (
    <div className="space-y-8">
      <Section title="Status">
        <Grid>
          <DetailField label="Rent Ready" name="rentReady" type="radio"
            options={radioOption}
            value={rentReadySelection(property.rentReady)} />
          <DetailField label="Lease Status" name="leaseStatus" type="select"
            options={leaseStatusOptions} value={property.leaseStatus} />
          <DetailField label="Is Listed" name="isListed" type="radio"
            options={radioOption}
            value={isListedSelection(property.isListed)} />
          <DetailField label="Is Active" name="isActive" type="radio"
            options={isActiveRadioOption}
            value={isActiveSelection(property.isActive)} />
        </Grid>
      </Section>

      <Section title="Dates">
        <Grid>
          <DetailField label="Available Date" name="availableDate" type="date"
            value={property.availableDate} />
          <DetailField label="Lease Start Date" name="leaseStartDate" type="date"
            value={property.leaseStartDate} />
          <DetailField label="Lease End Date" name="leaseEndDate" type="date"
            value={property.leaseEndDate} />
          <DetailField label="Notice Given Date" name="noticeGivenDate" type="date"
            value={property.noticeGivenDate} />
          <DetailField label="Move In Date" name="moveInDate" type="date"
            value={property.moveInDate} />
          <DetailField label="Move Out Date" name="moveOutDate" type="date"
            value={property.moveOutDate} />
          <DetailField label="Lease Signed Date" name="leaseSignedDate" type="date"
            value={property.leaseSignedDate} />
          <DetailField label="Listing Date" name="listingDate" type="date"
            value={property.listingDate} />
        </Grid>
      </Section>
    </div>
  );
}

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div>
    <Typography
      as="h3"
      className="text-sm font-semibold text-foreground border-b border-border pb-2 mb-4"
    >
      {title}
    </Typography>
    {children}
  </div>
);

const Grid = ({ children }: { children: React.ReactNode }) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-5">{children}</div>
);
